import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=10e22881&scoped=true&"
import script from "./UsersList.vue?vue&type=script&lang=js&"
export * from "./UsersList.vue?vue&type=script&lang=js&"
import style0 from "./UsersList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UsersList.vue?vue&type=style&index=1&id=10e22881&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e22881",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VBtn,VPagination,VWindow,VWindowItem})
